var map = {
	"./arrow.png": "061e",
	"./arrow_next.png": "c4d5",
	"./arrow_pre.png": "2fdb",
	"./ch/Application/daily/banner-1-m.jpg": "64b6",
	"./ch/Application/daily/banner-1.jpg": "d897",
	"./ch/Application/daily/custom.jpg": "6fd9",
	"./ch/Application/daily/different.png": "f0e6",
	"./ch/Application/daily/exhaustPipe-1.jpg": "742b",
	"./ch/Application/daily/exhaustPipe-2.jpg": "ddee",
	"./ch/Application/daily/min.png": "b76b",
	"./ch/Application/daily/safe.png": "2651",
	"./ch/Application/daily/size.png": "f8ce",
	"./ch/Application/daily/soft.png": "73ec",
	"./ch/Application/daily/stable.jpg": "c7e9",
	"./ch/Application/daily/transaction.png": "0c0b",
	"./ch/Application/household/banner-1-m.jpg": "6aa9",
	"./ch/Application/household/banner-1.jpg": "1448",
	"./ch/Application/household/certificate-1.jpg": "0817",
	"./ch/Application/household/certificate-2.jpg": "330a",
	"./ch/Application/household/certificate-3.jpg": "5ffd",
	"./ch/Application/household/certificate-4.jpg": "d7e7",
	"./ch/Application/household/certificate-5.jpg": "61e6",
	"./ch/Application/household/certificate-6.jpg": "2741",
	"./ch/Application/household/custom.jpg": "e769",
	"./ch/Application/household/different.jpg": "c568",
	"./ch/Application/household/hotelFamily-1.jpg": "5da4",
	"./ch/Application/household/hotelFamily-2.jpg": "d29d",
	"./ch/Application/household/hotelFamily-3.jpg": "bfd0",
	"./ch/Application/household/hotelFamily-4.jpg": "23af",
	"./ch/Application/household/hotelFamily-5.jpg": "2e92",
	"./ch/Application/household/hotelFamily-6.jpg": "946a",
	"./ch/Application/household/hotelFamily-7.jpg": "db84",
	"./ch/Application/household/hotelFamily-8.jpg": "55e6",
	"./ch/Application/household/hotelFamily-9.jpg": "398b",
	"./ch/Application/household/min.png": "6bd1",
	"./ch/Application/household/quality.jpg": "7c42",
	"./ch/Application/household/safe.png": "c123",
	"./ch/Application/household/size.png": "1c28",
	"./ch/Application/household/soft.png": "bfb1",
	"./ch/Application/household/stable.jpg": "7146",
	"./ch/Application/household/transaction.png": "c838",
	"./ch/Application/insulation/banner-1-m.jpg": "5dbb",
	"./ch/Application/insulation/banner-1.jpg": "58ce",
	"./ch/Application/insulation/custom.jpg": "3258",
	"./ch/Application/insulation/different.png": "9025",
	"./ch/Application/insulation/min.png": "22e3",
	"./ch/Application/insulation/safe.png": "2e02",
	"./ch/Application/insulation/size.png": "e523",
	"./ch/Application/insulation/soft.png": "5b99",
	"./ch/Application/insulation/stable.jpg": "830f",
	"./ch/Application/insulation/transaction.png": "9937",
	"./ch/Application/insulation/wire-1.jpg": "be6b",
	"./ch/Application/insulation/wire-2.jpg": "cace",
	"./ch/Application/insulation/wire-3.jpg": "8a81",
	"./ch/Application/insulation/wire-4.jpg": "deae",
	"./ch/Application/pipe/banner-1-m.jpg": "f68b",
	"./ch/Application/pipe/banner-1.jpg": "ee01",
	"./ch/Application/pipe/certificate-1.jpg": "a771",
	"./ch/Application/pipe/certificate-2.jpg": "07fd",
	"./ch/Application/pipe/custom.jpg": "62d2",
	"./ch/Application/pipe/different.png": "3971",
	"./ch/Application/pipe/min.png": "6bfe",
	"./ch/Application/pipe/pipe-1.jpg": "dbb44",
	"./ch/Application/pipe/pipe-2.jpg": "9e0a",
	"./ch/Application/pipe/pipe-3.png": "b5f6",
	"./ch/Application/pipe/pipe-4.jpg": "deac",
	"./ch/Application/pipe/pipe-5.jpg": "c7fb",
	"./ch/Application/pipe/pipe-6.jpg": "53c1",
	"./ch/Application/pipe/pipe-7.jpg": "8d14",
	"./ch/Application/pipe/safe.png": "558b",
	"./ch/Application/pipe/size.png": "ad57",
	"./ch/Application/pipe/soft.png": "2bba",
	"./ch/Application/pipe/stable.jpg": "4468",
	"./ch/Application/pipe/transaction.png": "ad70",
	"./ch/Application/seats/airplane-1.jpg": "bfd9",
	"./ch/Application/seats/airplane-2.jpg": "d46b",
	"./ch/Application/seats/airplane-3.jpg": "0a52",
	"./ch/Application/seats/airplane-4.jpg": "a468",
	"./ch/Application/seats/airplane-5.jpg": "2e8b",
	"./ch/Application/seats/airplane-6.jpg": "03f7",
	"./ch/Application/seats/banner-1-m.jpg": "3106",
	"./ch/Application/seats/banner-1.jpg": "f141",
	"./ch/Application/seats/bus-1.jpg": "bbc5",
	"./ch/Application/seats/car-1.jpg": "d9c9",
	"./ch/Application/seats/car-2.jpg": "c53c",
	"./ch/Application/seats/car-3.jpg": "7a47",
	"./ch/Application/seats/car-4.jpg": "5575",
	"./ch/Application/seats/car-5.jpg": "4a55",
	"./ch/Application/seats/certificate-1-1.jpg": "6a9b",
	"./ch/Application/seats/certificate-1-2.jpg": "767d",
	"./ch/Application/seats/certificate-1-3.jpg": "a796",
	"./ch/Application/seats/certificate-1-4.jpg": "b23a",
	"./ch/Application/seats/certificate-2-1.jpg": "e645",
	"./ch/Application/seats/certificate-2-2.jpg": "70ae",
	"./ch/Application/seats/certificate-2-3.jpg": "d8b6",
	"./ch/Application/seats/certificate-2-4.jpg": "70d6",
	"./ch/Application/seats/children-1.jpg": "0966",
	"./ch/Application/seats/children-2.jpg": "9c3f",
	"./ch/Application/seats/children-3.jpg": "0e01",
	"./ch/Application/seats/children-4.jpg": "852d",
	"./ch/Application/seats/custom.jpg": "8f11",
	"./ch/Application/seats/different.jpg": "231b",
	"./ch/Application/seats/highSpeedRail-1.jpg": "2cc5",
	"./ch/Application/seats/highSpeedRail-2.jpg": "8521",
	"./ch/Application/seats/highSpeedRail-3.jpg": "a3a5",
	"./ch/Application/seats/highSpeedRail-4.jpg": "4200",
	"./ch/Application/seats/highSpeedRail-5.jpg": "4c06",
	"./ch/Application/seats/min.png": "35b0",
	"./ch/Application/seats/movieTheater-1.jpg": "1a18",
	"./ch/Application/seats/movieTheater-2.jpg": "48c0",
	"./ch/Application/seats/movieTheater-3.jpg": "aed0",
	"./ch/Application/seats/safe.png": "d934",
	"./ch/Application/seats/size.png": "b34d",
	"./ch/Application/seats/soft.png": "b7ee",
	"./ch/Application/seats/stable.jpg": "6062",
	"./ch/Application/seats/transaction.png": "7cc3",
	"./ch/Application/seats/yacht-1.jpg": "44f6",
	"./ch/Application/seats/yacht-2.jpg": "cf1f",
	"./ch/Application/seats/yacht-3.jpg": "c749",
	"./ch/Application/seats/yacht-4.jpg": "a2a9",
	"./ch/Application/seats/yacht-5.jpg": "eda3",
	"./ch/Application/seats/yacht-6.jpg": "0f47",
	"./ch/Application/welding/banner-1-m.jpg": "b9d0",
	"./ch/Application/welding/banner-1.jpg": "96a1",
	"./ch/Application/welding/certificate-1-1.jpg": "ca8f",
	"./ch/Application/welding/certificate-1-2.jpg": "78a3",
	"./ch/Application/welding/certificate-1-3.jpg": "1680",
	"./ch/Application/welding/certificate-1-4.jpg": "9ba0",
	"./ch/Application/welding/certificate-1-5.jpg": "fa10",
	"./ch/Application/welding/certificate-1-6.jpg": "6650",
	"./ch/Application/welding/certificate-2-1.jpg": "d4c0",
	"./ch/Application/welding/custom.jpg": "78af",
	"./ch/Application/welding/different.png": "d48b",
	"./ch/Application/welding/min.png": "ff2b",
	"./ch/Application/welding/safe.png": "feda",
	"./ch/Application/welding/size.png": "d5aa",
	"./ch/Application/welding/soft.png": "895d",
	"./ch/Application/welding/stable.jpg": "5f3f",
	"./ch/Application/welding/transaction.png": "6135",
	"./ch/Application/welding/welding-1.jpg": "ddba",
	"./ch/Application/welding/welding-10.jpg": "21f2",
	"./ch/Application/welding/welding-11.jpg": "677b",
	"./ch/Application/welding/welding-12.jpg": "5202",
	"./ch/Application/welding/welding-13.jpg": "fcaf",
	"./ch/Application/welding/welding-2.jpg": "92f9",
	"./ch/Application/welding/welding-3.jpg": "2a65",
	"./ch/Application/welding/welding-4.jpg": "53f5",
	"./ch/Application/welding/welding-5.jpg": "47c8",
	"./ch/Application/welding/welding-6.jpg": "6c67",
	"./ch/Application/welding/welding-7.jpg": "248a",
	"./ch/Application/welding/welding-8.jpg": "a731",
	"./ch/Application/welding/welding-9.jpg": "54b9",
	"./ch/Certificate/banner-1-m.jpg": "1fee",
	"./ch/Certificate/banner-1.jpg": "46ae",
	"./ch/Certificate/certificate01-1.jpg": "be52",
	"./ch/Certificate/certificate01-2.jpg": "bb6c",
	"./ch/Certificate/certificate02-1-1.jpg": "4916",
	"./ch/Certificate/certificate02-1-2.jpg": "d408",
	"./ch/Certificate/certificate02-1-3.jpg": "47dc",
	"./ch/Certificate/certificate02-1-4.jpg": "3459",
	"./ch/Certificate/certificate02-1-5.jpg": "89b8",
	"./ch/Certificate/certificate02-1-6.jpg": "868f",
	"./ch/Certificate/certificate02-2-1.jpg": "19c7",
	"./ch/Certificate/certificate03-1-1.jpg": "8655",
	"./ch/Certificate/certificate03-1-2.jpg": "81fe",
	"./ch/Certificate/certificate03-1-3.jpg": "d3ba",
	"./ch/Certificate/certificate03-1-4.jpg": "87ca",
	"./ch/Certificate/certificate03-2-1.jpg": "c625",
	"./ch/Certificate/certificate03-2-2.jpg": "36d4",
	"./ch/Certificate/certificate03-2-3.jpg": "1f48",
	"./ch/Certificate/certificate03-2-4.jpg": "83cc",
	"./ch/Certificate/certificate04-1.jpg": "d623",
	"./ch/Certificate/certificate04-2.jpg": "f3db",
	"./ch/Certificate/certificate04-3.jpg": "af61",
	"./ch/Certificate/certificate04-4.jpg": "d498",
	"./ch/Certificate/certificate04-5.jpg": "0e93",
	"./ch/Certificate/certificate04-6.jpg": "4852",
	"./ch/Certificate/tab01.jpg": "70ed",
	"./ch/Certificate/tab02.jpg": "97ec",
	"./ch/Certificate/tab03.jpg": "2074",
	"./ch/Certificate/tab04.jpg": "b781",
	"./ch/Certificate/tab05.jpg": "4f78",
	"./ch/Certificate/tab06.jpg": "72ad",
	"./ch/Contact/banner-1-m.jpg": "cad7",
	"./ch/Contact/banner-1.jpg": "b911",
	"./ch/Customized/banner-1-m.jpg": "4fe7",
	"./ch/Customized/banner-1.jpg": "0f0a",
	"./ch/Customized/customized.jpg": "8f64",
	"./ch/Customized/customized_m.jpg": "e26f",
	"./ch/Examples/household/banner-1-m.jpg": "6625",
	"./ch/Examples/household/banner-1.jpg": "e488",
	"./ch/Examples/household/family-1.jpg": "36f7",
	"./ch/Examples/household/family-10.jpg": "f81d",
	"./ch/Examples/household/family-11.jpg": "9a88",
	"./ch/Examples/household/family-12.jpg": "a1eb",
	"./ch/Examples/household/family-13.png": "25db",
	"./ch/Examples/household/family-2.jpg": "b6f7",
	"./ch/Examples/household/family-3.jpg": "99ea",
	"./ch/Examples/household/family-4.jpg": "b9c9",
	"./ch/Examples/household/family-5.jpg": "1205",
	"./ch/Examples/household/family-6.jpg": "9310",
	"./ch/Examples/household/family-7.jpg": "6919",
	"./ch/Examples/household/family-8.jpg": "f716",
	"./ch/Examples/household/family-9.jpg": "8b8c",
	"./ch/Examples/household/family.jpg": "45c6",
	"./ch/Examples/household/restaurant-1.png": "9e39",
	"./ch/Examples/household/restaurant-2.jpg": "3f1d",
	"./ch/Examples/household/restaurant-3.jpg": "ae77",
	"./ch/Examples/household/restaurant-4.jpg": "6c76",
	"./ch/Examples/household/restaurant-5.jpg": "bb69",
	"./ch/Examples/household/restaurant.png": "cbe9",
	"./ch/Examples/pipe/banner-1-m.jpg": "f3ab",
	"./ch/Examples/pipe/banner-1.jpg": "ee86",
	"./ch/Examples/pipe/building95-1.jpg": "2943",
	"./ch/Examples/pipe/building95-2.jpg": "6992",
	"./ch/Examples/pipe/building95-3.jpg": "642b",
	"./ch/Examples/pipe/building95-4.jpg": "e1c7",
	"./ch/Examples/pipe/building95-5.jpg": "efe7",
	"./ch/Examples/pipe/building95-6.jpg": "4368",
	"./ch/Examples/pipe/building95.jpg": "04ed",
	"./ch/Examples/pipe/sea-1.jpg": "4c1d",
	"./ch/Examples/pipe/sea-2.jpg": "eb58",
	"./ch/Examples/pipe/sea-3.jpg": "46ae1",
	"./ch/Examples/pipe/sea-4.jpg": "48f7",
	"./ch/Examples/pipe/sea-5.jpg": "3276",
	"./ch/Examples/pipe/sea-6.jpg": "dc17",
	"./ch/Examples/pipe/sea.jpg": "b6a0",
	"./ch/Examples/pipe/seaPalace-1.jpg": "51f8",
	"./ch/Examples/pipe/seaPalace-2.jpg": "bf84",
	"./ch/Examples/pipe/seaPalace-3.jpg": "0a08",
	"./ch/Examples/pipe/seaPalace-4.jpg": "a574",
	"./ch/Examples/pipe/seaPalace.jpg": "f374",
	"./ch/Examples/pipe/taoyuan-1.jpg": "b0db",
	"./ch/Examples/pipe/taoyuan-2.jpg": "d5cd",
	"./ch/Examples/pipe/taoyuan-3.jpg": "10a0",
	"./ch/Examples/pipe/taoyuan-4.jpg": "4c36",
	"./ch/Examples/pipe/taoyuan-5.jpg": "e08c",
	"./ch/Examples/pipe/taoyuan-6.jpg": "d644",
	"./ch/Examples/pipe/taoyuan.jpg": "6640",
	"./ch/Examples/pipe/xinzhuang-1.jpg": "bc1d",
	"./ch/Examples/pipe/xinzhuang-2.jpg": "d8c6",
	"./ch/Examples/pipe/xinzhuang-3.jpg": "7738",
	"./ch/Examples/pipe/xinzhuang-4.jpg": "8b9a",
	"./ch/Examples/pipe/xinzhuang-5.jpg": "58cb",
	"./ch/Examples/pipe/xinzhuang.jpg": "84d1",
	"./ch/Examples/seats/banner-1-m.jpg": "e54d",
	"./ch/Examples/seats/banner-1.jpg": "894b",
	"./ch/Examples/seats/seat-1.jpg": "ae42",
	"./ch/Examples/seats/seat-2.jpg": "91eb",
	"./ch/Examples/seats/seat-3.jpg": "a30d",
	"./ch/Examples/seats/seat-4.jpg": "289f",
	"./ch/Examples/seats/seat-5.jpg": "316b",
	"./ch/Examples/seats/seat-6.jpg": "e847",
	"./ch/Examples/seats/seat-7.jpg": "51bf",
	"./ch/Examples/seats/seat.jpg": "f3ef",
	"./ch/Examples/seats/train-1.jpg": "23ad",
	"./ch/Examples/seats/train-10.jpg": "9a9f",
	"./ch/Examples/seats/train-11.jpg": "c34e",
	"./ch/Examples/seats/train-2.jpg": "8926",
	"./ch/Examples/seats/train-3.jpg": "ccd0",
	"./ch/Examples/seats/train-4.jpg": "0071",
	"./ch/Examples/seats/train-5.jpg": "55dd",
	"./ch/Examples/seats/train-6.jpg": "7de8",
	"./ch/Examples/seats/train-7.jpg": "39af",
	"./ch/Examples/seats/train-8.jpg": "46d7",
	"./ch/Examples/seats/train-9.jpg": "f102",
	"./ch/Examples/seats/train.png": "6174",
	"./ch/Examples/welding/FPG-1.jpg": "dfec",
	"./ch/Examples/welding/FPG-2.jpg": "5d25",
	"./ch/Examples/welding/FPG-3.jpg": "e0e7",
	"./ch/Examples/welding/FPG-4.jpg": "5221",
	"./ch/Examples/welding/FPG-5.jpg": "92dc",
	"./ch/Examples/welding/FPG-6.jpg": "1f0e",
	"./ch/Examples/welding/FPG.jpg": "906f",
	"./ch/Examples/welding/banner-1-m.jpg": "e1ee",
	"./ch/Examples/welding/banner-1.jpg": "9ff1",
	"./ch/Examples/welding/repair-1.jpg": "49c0",
	"./ch/Examples/welding/repair-2.jpg": "3dd8",
	"./ch/Examples/welding/repair-3.jpg": "8ef9",
	"./ch/Examples/welding/repair-4.jpg": "ffcc",
	"./ch/Examples/welding/repair-5.jpg": "5703",
	"./ch/Examples/welding/repair-6.jpg": "356e",
	"./ch/Examples/welding/repair-7.jpg": "49a4",
	"./ch/Examples/welding/repair.jpg": "a7cd",
	"./ch/Examples/welding/restaurant-1.jpg": "7657",
	"./ch/Examples/welding/restaurant-2.jpg": "5280",
	"./ch/Examples/welding/restaurant-3.jpg": "fa75",
	"./ch/Examples/welding/restaurant-4.jpg": "c1c3",
	"./ch/Examples/welding/restaurant-5.jpg": "8434",
	"./ch/Examples/welding/restaurant-6.jpg": "77d4",
	"./ch/Examples/welding/restaurant.jpg": "18e0",
	"./ch/Examples/welding/ship-1.jpg": "1f8c",
	"./ch/Examples/welding/ship-2.jpg": "add8",
	"./ch/Examples/welding/ship-3.jpg": "9935",
	"./ch/Examples/welding/ship-4.jpg": "3e01",
	"./ch/Examples/welding/ship.jpg": "b639",
	"./ch/Examples/welding/steel-1.jpg": "d52c",
	"./ch/Examples/welding/steel-2.jpg": "8798",
	"./ch/Examples/welding/steel-3.jpg": "9625",
	"./ch/Examples/welding/steel-4.jpg": "b0e3",
	"./ch/Examples/welding/steel-5.jpg": "6783",
	"./ch/Examples/welding/steel-6.jpg": "50dd",
	"./ch/Examples/welding/steel-7.jpg": "59e5",
	"./ch/Examples/welding/steel.jpg": "483b",
	"./ch/FireTest/banner-1-m.jpg": "2026",
	"./ch/FireTest/banner-1.jpg": "e8c6",
	"./ch/FireTest/test-1-2.jpg": "c58c",
	"./ch/FireTest/test.jpg": "61b7",
	"./ch/FireTest/test1-1.jpg": "38f0",
	"./ch/Home/application-title-m.png": "b66f",
	"./ch/Home/application-title.png": "eca5",
	"./ch/Home/banner-tc1-m.jpg": "74fe",
	"./ch/Home/banner-tc1.jpg": "932d",
	"./ch/Home/banner-tc2-m.jpg": "37d9",
	"./ch/Home/banner-tc2.jpg": "ac45",
	"./ch/Home/banner-tc3-m.jpg": "384c",
	"./ch/Home/banner-tc3.jpg": "cbdf",
	"./ch/Home/banner-tc4-m.jpg": "fb5d",
	"./ch/Home/banner-tc4.jpg": "6330",
	"./ch/Home/banner-tc5-m.jpg": "5f2f",
	"./ch/Home/banner-tc5.jpg": "b03f",
	"./ch/Home/blackcat1.jpg": "e19b",
	"./ch/Home/blackcat2.jpg": "fa90",
	"./ch/Home/btnCard-1-m.jpg": "62c9",
	"./ch/Home/btnCard-1.jpg": "ef20",
	"./ch/Home/btnCard-2-m.jpg": "f40f",
	"./ch/Home/btnCard-2.jpg": "a59a",
	"./ch/Home/btnCard-3-m.jpg": "43f7",
	"./ch/Home/btnCard-3.jpg": "9880",
	"./ch/Home/btnCard-4-m.jpg": "d721",
	"./ch/Home/btnCard-4.jpg": "6ffd",
	"./ch/Home/btnCard-5-m.jpg": "4e10",
	"./ch/Home/btnCard-5.jpg": "89e1",
	"./ch/Home/btnCard-6-m.jpg": "1c48",
	"./ch/Home/btnCard-6.jpg": "3465",
	"./ch/Home/btnCard-7-m.jpg": "7100",
	"./ch/Home/btnCard-7.jpg": "b1cf",
	"./ch/Home/btnCard-8-m.jpg": "447a",
	"./ch/Home/btnCard-8.jpg": "d9cb",
	"./ch/Home/c-thermometer-img1-2.png": "3504",
	"./ch/Home/c-thermometer-img2-2.png": "168e",
	"./ch/Home/c-thermometer-img3-2.png": "bb54",
	"./ch/Home/c-thermometer-img4-2.png": "fe6f",
	"./ch/Home/c-thermometer-img5-2.png": "f44b",
	"./ch/Home/c-thermometer-img6-2.png": "4e8c",
	"./ch/Home/c-thermometer-img7-1.jpg": "e280",
	"./ch/Home/c-thermometer-img7-2.jpg": "e09a",
	"./ch/Home/c-thermometer-img7-3.jpg": "b1c4",
	"./ch/Home/c-thermometer-img8-1.png": "5448",
	"./ch/Home/c-thermometer-img8-2.png": "dfc6",
	"./ch/Home/c-thermometer-img8-3.png": "a334",
	"./ch/Home/f-thermometer-img1-2.png": "d448",
	"./ch/Home/f-thermometer-img2-2.png": "d2e5",
	"./ch/Home/f-thermometer-img3-2.png": "4a35",
	"./ch/Home/f-thermometer-img4-2.png": "fee6",
	"./ch/Home/f-thermometer-img5-2.png": "28ee",
	"./ch/Home/f-thermometer-img6-2.png": "1ed7",
	"./ch/Home/f-thermometer-img7-1.jpg": "2fd9",
	"./ch/Home/f-thermometer-img7-2.jpg": "1f49",
	"./ch/Home/f-thermometer-img7-3.jpg": "9445",
	"./ch/Home/f-thermometer-img8-1.png": "912c",
	"./ch/Home/f-thermometer-img8-2.png": "546b",
	"./ch/Home/f-thermometer-img8-3.png": "3066",
	"./ch/Home/recommed-img1.jpg": "7bd6",
	"./ch/Home/recommed-img10.jpg": "2f16",
	"./ch/Home/recommed-img2.jpg": "8d69",
	"./ch/Home/recommed-img3.jpg": "51b4",
	"./ch/Home/recommed-img4.jpg": "b9b6",
	"./ch/Home/recommed-img5.jpg": "701a",
	"./ch/Home/recommed-img6.jpg": "f7a2",
	"./ch/Home/recommed-img7.jpg": "3f95",
	"./ch/Home/recommed-img8.jpg": "4c0c",
	"./ch/Home/recommed-img9.jpg": "e7b4",
	"./ch/Home/thermometer-arrow-1.png": "ba5f",
	"./ch/Home/thermometer-arrow-2.png": "4a49",
	"./ch/Home/thermometer-img1-1.png": "f131",
	"./ch/Home/thermometer-img2-1.png": "806c",
	"./ch/Home/thermometer-img3-1.png": "7399",
	"./ch/Home/thermometer-img4-1.png": "7fc9",
	"./ch/Home/thermometer-img5-1.png": "2119",
	"./ch/Home/thermometer-img6-1.png": "ff92",
	"./ch/Home/thermometer-title-m.png": "5c38",
	"./ch/Home/thermometer-title.png": "2365",
	"./chevron-up.png": "700e",
	"./en/Application/daily/banner-1-m.jpg": "7de3",
	"./en/Application/daily/banner-1.jpg": "78b1",
	"./en/Application/daily/custom.jpg": "5c22",
	"./en/Application/daily/different.png": "5873",
	"./en/Application/daily/exhaustPipe-1.jpg": "7c1f",
	"./en/Application/daily/exhaustPipe-2.jpg": "2759",
	"./en/Application/daily/min.png": "0b59",
	"./en/Application/daily/safe.png": "72bf",
	"./en/Application/daily/size.png": "316b9",
	"./en/Application/daily/soft.png": "92bd",
	"./en/Application/daily/stable.jpg": "21de",
	"./en/Application/daily/transaction.png": "1286",
	"./en/Application/household/banner-1-m.jpg": "ee24",
	"./en/Application/household/banner-1.jpg": "70df",
	"./en/Application/household/certificate-1.jpg": "367e",
	"./en/Application/household/certificate-2.jpg": "0326",
	"./en/Application/household/certificate-3.jpg": "5807",
	"./en/Application/household/certificate-4.jpg": "56da",
	"./en/Application/household/certificate-5.jpg": "b6cb",
	"./en/Application/household/certificate-6.jpg": "33e9",
	"./en/Application/household/custom.jpg": "2012",
	"./en/Application/household/different.jpg": "c994",
	"./en/Application/household/hotelFamily-1.jpg": "ae400",
	"./en/Application/household/hotelFamily-2.jpg": "1eb4",
	"./en/Application/household/hotelFamily-3.jpg": "4efa",
	"./en/Application/household/hotelFamily-4.jpg": "631e",
	"./en/Application/household/hotelFamily-5.jpg": "c8ff",
	"./en/Application/household/hotelFamily-6.jpg": "28b2",
	"./en/Application/household/hotelFamily-7.jpg": "19d2",
	"./en/Application/household/hotelFamily-8.jpg": "1eb0",
	"./en/Application/household/hotelFamily-9.jpg": "46bc",
	"./en/Application/household/min.png": "eaaf",
	"./en/Application/household/quality.jpg": "70b6",
	"./en/Application/household/safe.png": "d6e0",
	"./en/Application/household/size.png": "aeff",
	"./en/Application/household/soft.png": "17c8",
	"./en/Application/household/stable.jpg": "08e5",
	"./en/Application/household/transaction.png": "3580",
	"./en/Application/insulation/banner-1-m.jpg": "3400",
	"./en/Application/insulation/banner-1.jpg": "3b35",
	"./en/Application/insulation/custom.jpg": "166c",
	"./en/Application/insulation/different.png": "4416",
	"./en/Application/insulation/min.png": "9239",
	"./en/Application/insulation/safe.png": "96e9",
	"./en/Application/insulation/size.png": "8b9b",
	"./en/Application/insulation/soft.png": "c72d",
	"./en/Application/insulation/stable.jpg": "3a76",
	"./en/Application/insulation/transaction.png": "c211",
	"./en/Application/insulation/wire-1.jpg": "3062",
	"./en/Application/insulation/wire-2.jpg": "6f62",
	"./en/Application/insulation/wire-3.jpg": "e513",
	"./en/Application/insulation/wire-4.jpg": "ea4b",
	"./en/Application/pipe/banner-1-m.jpg": "a50d",
	"./en/Application/pipe/banner-1.jpg": "72bd",
	"./en/Application/pipe/certificate-1.jpg": "e0ef",
	"./en/Application/pipe/certificate-2.jpg": "7aa7",
	"./en/Application/pipe/custom.jpg": "0483",
	"./en/Application/pipe/different.png": "855f",
	"./en/Application/pipe/min.png": "44cc",
	"./en/Application/pipe/pipe-1.jpg": "83b8",
	"./en/Application/pipe/pipe-2.jpg": "8c53",
	"./en/Application/pipe/pipe-3.png": "80d3",
	"./en/Application/pipe/pipe-4.jpg": "7d4e",
	"./en/Application/pipe/pipe-5.jpg": "3481",
	"./en/Application/pipe/pipe-6.jpg": "9a59",
	"./en/Application/pipe/pipe-7.jpg": "28bc",
	"./en/Application/pipe/safe.png": "b95b",
	"./en/Application/pipe/size.png": "1530",
	"./en/Application/pipe/soft.png": "591a",
	"./en/Application/pipe/stable.jpg": "4ba4",
	"./en/Application/pipe/transaction.png": "001a",
	"./en/Application/seats/airplane-1.jpg": "5a9f",
	"./en/Application/seats/airplane-2.jpg": "d4cd",
	"./en/Application/seats/airplane-3.jpg": "4c8e",
	"./en/Application/seats/airplane-4.jpg": "36ce",
	"./en/Application/seats/airplane-5.jpg": "f6a0",
	"./en/Application/seats/airplane-6.jpg": "f3e7",
	"./en/Application/seats/banner-1-m.jpg": "bd03",
	"./en/Application/seats/banner-1.jpg": "5b1c",
	"./en/Application/seats/bus-1.jpg": "b1f5",
	"./en/Application/seats/car-1.jpg": "7f0e",
	"./en/Application/seats/car-2.jpg": "ae03",
	"./en/Application/seats/car-3.jpg": "1918",
	"./en/Application/seats/car-4.jpg": "6528",
	"./en/Application/seats/car-5.jpg": "6531",
	"./en/Application/seats/certificate-1-1.jpg": "8676",
	"./en/Application/seats/certificate-1-2.jpg": "9ea7",
	"./en/Application/seats/certificate-1-3.jpg": "f571",
	"./en/Application/seats/certificate-1-4.jpg": "4e58",
	"./en/Application/seats/certificate-2-1.jpg": "b8bc",
	"./en/Application/seats/certificate-2-2.jpg": "2c02",
	"./en/Application/seats/certificate-2-3.jpg": "07a9",
	"./en/Application/seats/certificate-2-4.jpg": "8554",
	"./en/Application/seats/children-1.jpg": "2f68",
	"./en/Application/seats/children-2.jpg": "5263",
	"./en/Application/seats/children-3.jpg": "f3a3",
	"./en/Application/seats/children-4.jpg": "6747",
	"./en/Application/seats/custom.jpg": "d768",
	"./en/Application/seats/different.jpg": "9bf3",
	"./en/Application/seats/highSpeedRail-1.jpg": "d315",
	"./en/Application/seats/highSpeedRail-2.jpg": "6e5e",
	"./en/Application/seats/highSpeedRail-3.jpg": "734c",
	"./en/Application/seats/highSpeedRail-4.jpg": "9adb",
	"./en/Application/seats/highSpeedRail-5.jpg": "6153",
	"./en/Application/seats/min.png": "5d96",
	"./en/Application/seats/movieTheater-1.jpg": "f44f",
	"./en/Application/seats/movieTheater-2.jpg": "8d39",
	"./en/Application/seats/movieTheater-3.jpg": "af1e",
	"./en/Application/seats/safe.png": "5fbd",
	"./en/Application/seats/size.png": "2564",
	"./en/Application/seats/soft.png": "b602",
	"./en/Application/seats/stable.jpg": "590c",
	"./en/Application/seats/transaction.png": "a9b8",
	"./en/Application/seats/yacht-1.jpg": "4dc8",
	"./en/Application/seats/yacht-2.jpg": "59c9",
	"./en/Application/seats/yacht-3.jpg": "9111",
	"./en/Application/seats/yacht-4.jpg": "241b",
	"./en/Application/seats/yacht-5.jpg": "1420",
	"./en/Application/seats/yacht-6.jpg": "dc06",
	"./en/Application/welding/banner-1-m.jpg": "4ed8",
	"./en/Application/welding/banner-1.jpg": "7e69",
	"./en/Application/welding/certificate-1-1.jpg": "20d5",
	"./en/Application/welding/certificate-1-2.jpg": "7db5",
	"./en/Application/welding/certificate-1-3.jpg": "d8aa",
	"./en/Application/welding/certificate-1-4.jpg": "3efc",
	"./en/Application/welding/certificate-1-5.jpg": "73b5",
	"./en/Application/welding/certificate-1-6.jpg": "69c5",
	"./en/Application/welding/certificate-2-1.jpg": "b2e5",
	"./en/Application/welding/custom.jpg": "e8a0",
	"./en/Application/welding/different.png": "88d3",
	"./en/Application/welding/min.png": "afc3",
	"./en/Application/welding/safe.png": "cc54",
	"./en/Application/welding/size.png": "30c9",
	"./en/Application/welding/soft.png": "73ed",
	"./en/Application/welding/stable.jpg": "5a4d",
	"./en/Application/welding/transaction.png": "69a5",
	"./en/Application/welding/welding-1.jpg": "7c87",
	"./en/Application/welding/welding-10.jpg": "f4e1",
	"./en/Application/welding/welding-11.jpg": "65cb",
	"./en/Application/welding/welding-12.jpg": "bbc4",
	"./en/Application/welding/welding-13.jpg": "efee",
	"./en/Application/welding/welding-2.jpg": "b155",
	"./en/Application/welding/welding-3.jpg": "7f9d",
	"./en/Application/welding/welding-4.jpg": "2d95",
	"./en/Application/welding/welding-5.jpg": "bdd1",
	"./en/Application/welding/welding-6.jpg": "7e96",
	"./en/Application/welding/welding-7.jpg": "0633",
	"./en/Application/welding/welding-8.jpg": "f7ce",
	"./en/Application/welding/welding-9.jpg": "4ace",
	"./en/Certificate/banner-1-m.jpg": "f83f",
	"./en/Certificate/banner-1.jpg": "ebf5",
	"./en/Certificate/certificate01-1.jpg": "5420",
	"./en/Certificate/certificate01-2.jpg": "ef24",
	"./en/Certificate/certificate02-1-1.jpg": "b2c2",
	"./en/Certificate/certificate02-1-2.jpg": "ba6c",
	"./en/Certificate/certificate02-1-3.jpg": "cbf1",
	"./en/Certificate/certificate02-1-4.jpg": "349c",
	"./en/Certificate/certificate02-1-5.jpg": "3d7a",
	"./en/Certificate/certificate02-1-6.jpg": "4190",
	"./en/Certificate/certificate02-2-1.jpg": "0210",
	"./en/Certificate/certificate03-1-1.jpg": "1764",
	"./en/Certificate/certificate03-1-2.jpg": "6375",
	"./en/Certificate/certificate03-1-3.jpg": "15bd",
	"./en/Certificate/certificate03-1-4.jpg": "d4a9",
	"./en/Certificate/certificate03-2-1.jpg": "f101",
	"./en/Certificate/certificate03-2-2.jpg": "95e8",
	"./en/Certificate/certificate03-2-3.jpg": "78dc",
	"./en/Certificate/certificate03-2-4.jpg": "cd4a",
	"./en/Certificate/certificate04-1.jpg": "5e90",
	"./en/Certificate/certificate04-2.jpg": "a254",
	"./en/Certificate/certificate04-3.jpg": "0774",
	"./en/Certificate/certificate04-4.jpg": "9a7c",
	"./en/Certificate/certificate04-5.jpg": "f752",
	"./en/Certificate/certificate04-6.jpg": "7efc",
	"./en/Certificate/tab01.jpg": "21e0",
	"./en/Certificate/tab02.jpg": "9f29",
	"./en/Certificate/tab03.jpg": "30b5",
	"./en/Certificate/tab04.jpg": "5536",
	"./en/Certificate/tab05.jpg": "71b3",
	"./en/Certificate/tab06.jpg": "133f",
	"./en/Contact/banner-1-m.jpg": "d3bc",
	"./en/Contact/banner-1.jpg": "e1f9",
	"./en/Customized/banner-1-m.jpg": "0988",
	"./en/Customized/banner-1.jpg": "7724",
	"./en/Customized/customized.jpg": "efc2",
	"./en/Customized/customized_m.jpg": "8c16",
	"./en/Examples/household/banner-1-m.jpg": "83cf",
	"./en/Examples/household/banner-1.jpg": "c28b",
	"./en/Examples/household/family-1.jpg": "bb7b",
	"./en/Examples/household/family-10.jpg": "b20a",
	"./en/Examples/household/family-11.jpg": "566e",
	"./en/Examples/household/family-12.jpg": "ae9d",
	"./en/Examples/household/family-13.png": "369c",
	"./en/Examples/household/family-2.jpg": "59db",
	"./en/Examples/household/family-3.jpg": "9793",
	"./en/Examples/household/family-4.jpg": "419f",
	"./en/Examples/household/family-5.jpg": "cb0b",
	"./en/Examples/household/family-6.jpg": "0435",
	"./en/Examples/household/family-7.jpg": "2b76",
	"./en/Examples/household/family-8.jpg": "c98a",
	"./en/Examples/household/family-9.jpg": "885c",
	"./en/Examples/household/family.jpg": "3ab5",
	"./en/Examples/household/restaurant-1.png": "a93d",
	"./en/Examples/household/restaurant-2.jpg": "f77b",
	"./en/Examples/household/restaurant-3.jpg": "a479",
	"./en/Examples/household/restaurant-4.jpg": "18e3",
	"./en/Examples/household/restaurant-5.jpg": "cd8d",
	"./en/Examples/household/restaurant.png": "1338",
	"./en/Examples/pipe/banner-1-m.jpg": "8608",
	"./en/Examples/pipe/banner-1.jpg": "6dd7",
	"./en/Examples/pipe/building95-1.jpg": "e016",
	"./en/Examples/pipe/building95-2.jpg": "415c",
	"./en/Examples/pipe/building95-3.jpg": "9b85",
	"./en/Examples/pipe/building95-4.jpg": "31c0",
	"./en/Examples/pipe/building95-5.jpg": "8f0b",
	"./en/Examples/pipe/building95-6.jpg": "9605",
	"./en/Examples/pipe/building95.jpg": "3525",
	"./en/Examples/pipe/sea-1.jpg": "91ed",
	"./en/Examples/pipe/sea-2.jpg": "376c",
	"./en/Examples/pipe/sea-3.jpg": "32d2",
	"./en/Examples/pipe/sea-4.jpg": "1805",
	"./en/Examples/pipe/sea-5.jpg": "be27",
	"./en/Examples/pipe/sea-6.jpg": "6643",
	"./en/Examples/pipe/sea.jpg": "71d5",
	"./en/Examples/pipe/seaPalace-1.jpg": "8b9a4",
	"./en/Examples/pipe/seaPalace-2.jpg": "b22b",
	"./en/Examples/pipe/seaPalace-3.jpg": "d595",
	"./en/Examples/pipe/seaPalace-4.jpg": "42001",
	"./en/Examples/pipe/seaPalace.jpg": "697e",
	"./en/Examples/pipe/taoyuan-1.jpg": "43be",
	"./en/Examples/pipe/taoyuan-2.jpg": "7cbc",
	"./en/Examples/pipe/taoyuan-3.jpg": "f989",
	"./en/Examples/pipe/taoyuan-4.jpg": "9971",
	"./en/Examples/pipe/taoyuan-5.jpg": "88ba",
	"./en/Examples/pipe/taoyuan-6.jpg": "bedc",
	"./en/Examples/pipe/taoyuan.jpg": "ebd4",
	"./en/Examples/pipe/xinzhuang-1.jpg": "916a",
	"./en/Examples/pipe/xinzhuang-2.jpg": "7a2b",
	"./en/Examples/pipe/xinzhuang-3.jpg": "97a3",
	"./en/Examples/pipe/xinzhuang-4.jpg": "ba85",
	"./en/Examples/pipe/xinzhuang-5.jpg": "9334",
	"./en/Examples/pipe/xinzhuang.jpg": "d4f9",
	"./en/Examples/seats/banner-1-m.jpg": "af8f",
	"./en/Examples/seats/banner-1.jpg": "a64f",
	"./en/Examples/seats/seat-1.jpg": "ade4",
	"./en/Examples/seats/seat-2.jpg": "e5f0",
	"./en/Examples/seats/seat-3.jpg": "535b",
	"./en/Examples/seats/seat-4.jpg": "914f",
	"./en/Examples/seats/seat-5.jpg": "cca0",
	"./en/Examples/seats/seat-6.jpg": "775f",
	"./en/Examples/seats/seat-7.jpg": "8ddc",
	"./en/Examples/seats/seat.jpg": "a01d",
	"./en/Examples/seats/train-1.jpg": "9592",
	"./en/Examples/seats/train-10.jpg": "2991",
	"./en/Examples/seats/train-11.jpg": "6746",
	"./en/Examples/seats/train-2.jpg": "b2cd",
	"./en/Examples/seats/train-3.jpg": "f3fe",
	"./en/Examples/seats/train-4.jpg": "5260",
	"./en/Examples/seats/train-5.jpg": "ca87",
	"./en/Examples/seats/train-6.jpg": "cde7",
	"./en/Examples/seats/train-7.jpg": "2988",
	"./en/Examples/seats/train-8.jpg": "bb52",
	"./en/Examples/seats/train-9.jpg": "689f",
	"./en/Examples/seats/train.png": "ac5b",
	"./en/Examples/welding/FPG-1.jpg": "302e",
	"./en/Examples/welding/FPG-2.jpg": "899d",
	"./en/Examples/welding/FPG-3.jpg": "b194",
	"./en/Examples/welding/FPG-4.jpg": "90a7",
	"./en/Examples/welding/FPG-5.jpg": "822a",
	"./en/Examples/welding/FPG-6.jpg": "3900",
	"./en/Examples/welding/FPG.jpg": "da93",
	"./en/Examples/welding/banner-1-m.jpg": "e772",
	"./en/Examples/welding/banner-1.jpg": "ff1f",
	"./en/Examples/welding/repair-1.jpg": "dfd3",
	"./en/Examples/welding/repair-2.jpg": "fc45",
	"./en/Examples/welding/repair-3.jpg": "db99",
	"./en/Examples/welding/repair-4.jpg": "15f2",
	"./en/Examples/welding/repair-5.jpg": "8929",
	"./en/Examples/welding/repair-6.jpg": "3265",
	"./en/Examples/welding/repair-7.jpg": "a3d8",
	"./en/Examples/welding/repair.jpg": "3940",
	"./en/Examples/welding/restaurant-1.jpg": "72a7",
	"./en/Examples/welding/restaurant-2.jpg": "388a",
	"./en/Examples/welding/restaurant-3.jpg": "57bb",
	"./en/Examples/welding/restaurant-4.jpg": "f972",
	"./en/Examples/welding/restaurant-5.jpg": "e427",
	"./en/Examples/welding/restaurant-6.jpg": "b16f",
	"./en/Examples/welding/restaurant.jpg": "03cd",
	"./en/Examples/welding/ship-1.jpg": "b361",
	"./en/Examples/welding/ship-2.jpg": "dabf",
	"./en/Examples/welding/ship-3.jpg": "fdb3",
	"./en/Examples/welding/ship-4.jpg": "204d",
	"./en/Examples/welding/ship.jpg": "7beb",
	"./en/Examples/welding/steel-1.jpg": "2b96",
	"./en/Examples/welding/steel-2.jpg": "ab2a",
	"./en/Examples/welding/steel-3.jpg": "b272",
	"./en/Examples/welding/steel-4.jpg": "6d12",
	"./en/Examples/welding/steel-5.jpg": "0286",
	"./en/Examples/welding/steel-6.jpg": "f02f",
	"./en/Examples/welding/steel-7.jpg": "d9c3",
	"./en/Examples/welding/steel.jpg": "2db2",
	"./en/FireTest/banner-1-m.jpg": "3ce7",
	"./en/FireTest/banner-1.jpg": "0478",
	"./en/FireTest/test.jpg": "73a1",
	"./en/FireTest/test01-1.jpg": "36ea",
	"./en/FireTest/test01-2.jpg": "83a4",
	"./en/FireTest/test01-3.jpg": "27c5",
	"./en/FireTest/test01-4.jpg": "3df9",
	"./en/FireTest/test01-5.jpg": "7c45",
	"./en/FireTest/test01-6.jpg": "2e84",
	"./en/FireTest/test02-1.jpg": "345b",
	"./en/FireTest/test02-2.jpg": "c3b2",
	"./en/FireTest/test03-1.jpg": "6372",
	"./en/FireTest/test03-2.jpg": "039c",
	"./en/FireTest/test03-3.jpg": "8063",
	"./en/FireTest/test03-4.jpg": "9e3f",
	"./en/FireTest/test03-5.jpg": "e7b6",
	"./en/FireTest/test03-6.jpg": "f048",
	"./en/FireTest/test04-1.jpg": "e0ab",
	"./en/FireTest/test04-2.jpg": "ae6e",
	"./en/Home/application-title-m.png": "d1f6",
	"./en/Home/application-title.png": "a510",
	"./en/Home/banner-tc1-m.jpg": "00b3",
	"./en/Home/banner-tc1.jpg": "56fe",
	"./en/Home/banner-tc2-m.jpg": "2177",
	"./en/Home/banner-tc2.jpg": "fb49",
	"./en/Home/banner-tc3-m.jpg": "c352",
	"./en/Home/banner-tc3.jpg": "54a8",
	"./en/Home/banner-tc4-m.jpg": "f2d4",
	"./en/Home/banner-tc4.jpg": "fc27",
	"./en/Home/banner-tc5-m.jpg": "6131",
	"./en/Home/banner-tc5.jpg": "605b",
	"./en/Home/blackcat1.jpg": "2073",
	"./en/Home/blackcat2.jpg": "e0f6",
	"./en/Home/btnCard-1-m.jpg": "6dd3",
	"./en/Home/btnCard-1.jpg": "49c1",
	"./en/Home/btnCard-2-m.jpg": "aace",
	"./en/Home/btnCard-2.jpg": "6aa0",
	"./en/Home/btnCard-3-m.jpg": "ec10",
	"./en/Home/btnCard-3.jpg": "393f",
	"./en/Home/btnCard-4-m.jpg": "6806",
	"./en/Home/btnCard-4.jpg": "2095",
	"./en/Home/btnCard-5-m.jpg": "19a4",
	"./en/Home/btnCard-5.jpg": "b62f",
	"./en/Home/btnCard-6-m.jpg": "19a9",
	"./en/Home/btnCard-6.jpg": "0f9f",
	"./en/Home/btnCard-7-m.jpg": "66fe",
	"./en/Home/btnCard-7.jpg": "2bf0",
	"./en/Home/btnCard-8-m.jpg": "7d8c",
	"./en/Home/btnCard-8.jpg": "3edc",
	"./en/Home/c-thermometer-img1-2.png": "a065",
	"./en/Home/c-thermometer-img2-2.png": "de59",
	"./en/Home/c-thermometer-img3-2.png": "f024",
	"./en/Home/c-thermometer-img4-2.png": "6eb1",
	"./en/Home/c-thermometer-img5-2.png": "ee28",
	"./en/Home/c-thermometer-img6-2.png": "8ca5",
	"./en/Home/c-thermometer-img7-1.jpg": "9ff0",
	"./en/Home/c-thermometer-img7-2.jpg": "0459",
	"./en/Home/c-thermometer-img7-3.jpg": "d769",
	"./en/Home/c-thermometer-img8-1.png": "757f",
	"./en/Home/c-thermometer-img8-2.png": "78e3",
	"./en/Home/c-thermometer-img8-3.png": "5107",
	"./en/Home/f-thermometer-img1-2.png": "7394",
	"./en/Home/f-thermometer-img2-2.png": "ca20",
	"./en/Home/f-thermometer-img3-2.png": "97f9",
	"./en/Home/f-thermometer-img4-2.png": "3196",
	"./en/Home/f-thermometer-img5-2.png": "74ff",
	"./en/Home/f-thermometer-img6-2.png": "8994",
	"./en/Home/f-thermometer-img7-1.jpg": "80d9",
	"./en/Home/f-thermometer-img7-2.jpg": "3fe2",
	"./en/Home/f-thermometer-img7-3.jpg": "731f",
	"./en/Home/f-thermometer-img8-1.png": "727d",
	"./en/Home/f-thermometer-img8-2.png": "7586",
	"./en/Home/f-thermometer-img8-3.png": "642e",
	"./en/Home/recommed-img1.jpg": "e57d",
	"./en/Home/recommed-img10.jpg": "7b35",
	"./en/Home/recommed-img2.jpg": "d0b4",
	"./en/Home/recommed-img3.jpg": "36c2",
	"./en/Home/recommed-img4.jpg": "4c54",
	"./en/Home/recommed-img5.jpg": "175f",
	"./en/Home/recommed-img6.jpg": "bc7c",
	"./en/Home/recommed-img7.jpg": "5266",
	"./en/Home/recommed-img8.jpg": "df95",
	"./en/Home/recommed-img9.jpg": "3154",
	"./en/Home/thermometer-arrow-1.png": "a6e1",
	"./en/Home/thermometer-arrow-2.png": "5e80",
	"./en/Home/thermometer-img1-1.png": "be86",
	"./en/Home/thermometer-img2-1.png": "350a",
	"./en/Home/thermometer-img3-1.png": "47a8",
	"./en/Home/thermometer-img4-1.png": "7074",
	"./en/Home/thermometer-img5-1.png": "8763",
	"./en/Home/thermometer-img6-1.png": "1a3a",
	"./en/Home/thermometer-title-m.png": "c86d",
	"./en/Home/thermometer-title.png": "11b7",
	"./en/test.jpg": "c4e8",
	"./footer_QRCode_01.png": "e390",
	"./footer_company_01.png": "3176",
	"./footer_company_02.png": "9198",
	"./footer_company_03.png": "ad0a",
	"./footer_company_05.png": "625c",
	"./footer_company_06.png": "d189",
	"./footer_company_07.png": "d8fb",
	"./frame.png": "5996",
	"./home-contact-m.png": "2bc2",
	"./home-contact.png": "d9c7",
	"./home-next.png": "2b90",
	"./home-pre.png": "0091",
	"./icon-global1.png": "c664",
	"./logo.png": "9d64",
	"./menu.png": "11ab",
	"./nacmenu-link.svg": "1e1e",
	"./nanya-house.png": "62e1",
	"./refresh.png": "15c8",
	"./select_arrow.png": "3eda",
	"./zh/Application/daily/banner-1-m.jpg": "0005",
	"./zh/Application/daily/banner-1.jpg": "ad75",
	"./zh/Application/daily/custom.jpg": "c388",
	"./zh/Application/daily/different.png": "77a4",
	"./zh/Application/daily/exhaustPipe-1.jpg": "a258",
	"./zh/Application/daily/exhaustPipe-2.jpg": "2874",
	"./zh/Application/daily/min.png": "b6ce",
	"./zh/Application/daily/safe.png": "439d",
	"./zh/Application/daily/size.png": "6c86",
	"./zh/Application/daily/soft.png": "71e9",
	"./zh/Application/daily/stable.jpg": "e3af",
	"./zh/Application/daily/transaction.png": "4646",
	"./zh/Application/household/banner-1-m.jpg": "a323",
	"./zh/Application/household/banner-1.jpg": "4159",
	"./zh/Application/household/certificate-1.jpg": "e71c",
	"./zh/Application/household/certificate-2.jpg": "13ae",
	"./zh/Application/household/certificate-3.jpg": "6876",
	"./zh/Application/household/certificate-4.jpg": "8976",
	"./zh/Application/household/certificate-5.jpg": "8966",
	"./zh/Application/household/certificate-6.jpg": "43ac",
	"./zh/Application/household/custom.jpg": "acb5",
	"./zh/Application/household/different.jpg": "ae57",
	"./zh/Application/household/hotelFamily-1.jpg": "92af",
	"./zh/Application/household/hotelFamily-2.jpg": "aa25",
	"./zh/Application/household/hotelFamily-3.jpg": "6e2a",
	"./zh/Application/household/hotelFamily-4.jpg": "2945",
	"./zh/Application/household/hotelFamily-5.jpg": "9123",
	"./zh/Application/household/hotelFamily-6.jpg": "0649",
	"./zh/Application/household/hotelFamily-7.jpg": "e9a2",
	"./zh/Application/household/hotelFamily-8.jpg": "63d8",
	"./zh/Application/household/hotelFamily-9.jpg": "84342",
	"./zh/Application/household/min.png": "e25b",
	"./zh/Application/household/quality.jpg": "0ec4",
	"./zh/Application/household/safe.png": "95f4",
	"./zh/Application/household/size.png": "5751",
	"./zh/Application/household/soft.png": "9c4f",
	"./zh/Application/household/stable.jpg": "acc1",
	"./zh/Application/household/transaction.png": "f246",
	"./zh/Application/insulation/banner-1-m.jpg": "a0b2",
	"./zh/Application/insulation/banner-1.jpg": "2f6b",
	"./zh/Application/insulation/custom.jpg": "704d",
	"./zh/Application/insulation/different.png": "b2ae",
	"./zh/Application/insulation/min.png": "cecc",
	"./zh/Application/insulation/safe.png": "fd2b",
	"./zh/Application/insulation/size.png": "3e12",
	"./zh/Application/insulation/soft.png": "36d7",
	"./zh/Application/insulation/stable.jpg": "aed8",
	"./zh/Application/insulation/transaction.png": "6472",
	"./zh/Application/insulation/wire-1.jpg": "2865",
	"./zh/Application/insulation/wire-2.jpg": "620d",
	"./zh/Application/insulation/wire-3.jpg": "5455",
	"./zh/Application/insulation/wire-4.jpg": "f77a",
	"./zh/Application/pipe/banner-1-m.jpg": "82a5",
	"./zh/Application/pipe/banner-1.jpg": "e866",
	"./zh/Application/pipe/certificate-1.jpg": "7243",
	"./zh/Application/pipe/certificate-2.jpg": "c310",
	"./zh/Application/pipe/custom.jpg": "1fb2",
	"./zh/Application/pipe/different.png": "f5e4",
	"./zh/Application/pipe/min.png": "f157",
	"./zh/Application/pipe/pipe-1.jpg": "f18a",
	"./zh/Application/pipe/pipe-2.jpg": "e049",
	"./zh/Application/pipe/pipe-3.png": "6c81",
	"./zh/Application/pipe/pipe-4.jpg": "ead8",
	"./zh/Application/pipe/pipe-5.jpg": "a0f8",
	"./zh/Application/pipe/pipe-6.jpg": "9ecb",
	"./zh/Application/pipe/pipe-7.jpg": "6c53",
	"./zh/Application/pipe/safe.png": "4241",
	"./zh/Application/pipe/size.png": "bbd3",
	"./zh/Application/pipe/soft.png": "35c9",
	"./zh/Application/pipe/stable.jpg": "289e",
	"./zh/Application/pipe/transaction.png": "b555",
	"./zh/Application/seats/airplane-1.jpg": "e084",
	"./zh/Application/seats/airplane-2.jpg": "fcbf",
	"./zh/Application/seats/airplane-3.jpg": "5dd0",
	"./zh/Application/seats/airplane-4.jpg": "0d57",
	"./zh/Application/seats/airplane-5.jpg": "4fba",
	"./zh/Application/seats/airplane-6.jpg": "9ddf",
	"./zh/Application/seats/banner-1-m.jpg": "e501",
	"./zh/Application/seats/banner-1.jpg": "711d",
	"./zh/Application/seats/bus-1.jpg": "cbe5",
	"./zh/Application/seats/car-1.jpg": "f36c",
	"./zh/Application/seats/car-2.jpg": "7715",
	"./zh/Application/seats/car-3.jpg": "1056",
	"./zh/Application/seats/car-4.jpg": "5c09",
	"./zh/Application/seats/car-5.jpg": "980a",
	"./zh/Application/seats/certificate-1-1.jpg": "035a",
	"./zh/Application/seats/certificate-1-2.jpg": "944c",
	"./zh/Application/seats/certificate-1-3.jpg": "d05d",
	"./zh/Application/seats/certificate-1-4.jpg": "c57b",
	"./zh/Application/seats/certificate-2-1.jpg": "58f1",
	"./zh/Application/seats/certificate-2-2.jpg": "e164",
	"./zh/Application/seats/certificate-2-3.jpg": "d3e7",
	"./zh/Application/seats/certificate-2-4.jpg": "07af",
	"./zh/Application/seats/children-1.jpg": "d067",
	"./zh/Application/seats/children-2.jpg": "60e2",
	"./zh/Application/seats/children-3.jpg": "64ed",
	"./zh/Application/seats/children-4.jpg": "31f7",
	"./zh/Application/seats/custom.jpg": "e88a",
	"./zh/Application/seats/different.jpg": "12b2",
	"./zh/Application/seats/highSpeedRail-1.jpg": "4622",
	"./zh/Application/seats/highSpeedRail-2.jpg": "837a",
	"./zh/Application/seats/highSpeedRail-3.jpg": "deb0",
	"./zh/Application/seats/highSpeedRail-4.jpg": "0655",
	"./zh/Application/seats/highSpeedRail-5.jpg": "3124",
	"./zh/Application/seats/min.png": "fb10",
	"./zh/Application/seats/movieTheater-1.jpg": "cd10",
	"./zh/Application/seats/movieTheater-2.jpg": "117a",
	"./zh/Application/seats/movieTheater-3.jpg": "5a3e",
	"./zh/Application/seats/safe.png": "9800",
	"./zh/Application/seats/size.png": "cc6b",
	"./zh/Application/seats/soft.png": "6bdb",
	"./zh/Application/seats/stable.jpg": "5929",
	"./zh/Application/seats/transaction.png": "4dd3",
	"./zh/Application/seats/yacht-1.jpg": "ae5f",
	"./zh/Application/seats/yacht-2.jpg": "6f35",
	"./zh/Application/seats/yacht-3.jpg": "fa2e",
	"./zh/Application/seats/yacht-4.jpg": "28f0",
	"./zh/Application/seats/yacht-5.jpg": "a9a6",
	"./zh/Application/seats/yacht-6.jpg": "4499",
	"./zh/Application/welding/banner-1-m.jpg": "95c0",
	"./zh/Application/welding/banner-1.jpg": "8a3b",
	"./zh/Application/welding/certificate-1-1.jpg": "b4e3",
	"./zh/Application/welding/certificate-1-2.jpg": "e1d3",
	"./zh/Application/welding/certificate-1-3.jpg": "ad27",
	"./zh/Application/welding/certificate-1-4.jpg": "47e0",
	"./zh/Application/welding/certificate-1-5.jpg": "26c5",
	"./zh/Application/welding/certificate-1-6.jpg": "4d94",
	"./zh/Application/welding/certificate-2-1.jpg": "042c",
	"./zh/Application/welding/custom.jpg": "3c66",
	"./zh/Application/welding/different.png": "0b51",
	"./zh/Application/welding/min.png": "5ad5",
	"./zh/Application/welding/safe.png": "2a12",
	"./zh/Application/welding/size.png": "8381",
	"./zh/Application/welding/soft.png": "57fb",
	"./zh/Application/welding/stable.jpg": "cdcf",
	"./zh/Application/welding/transaction.png": "1087",
	"./zh/Application/welding/welding-1.jpg": "893d",
	"./zh/Application/welding/welding-10.jpg": "73a9",
	"./zh/Application/welding/welding-11.jpg": "e8da",
	"./zh/Application/welding/welding-12.jpg": "f573",
	"./zh/Application/welding/welding-2.jpg": "1df5",
	"./zh/Application/welding/welding-3.jpg": "00d4",
	"./zh/Application/welding/welding-4.jpg": "fef5",
	"./zh/Application/welding/welding-5.jpg": "5891",
	"./zh/Application/welding/welding-6.jpg": "17c1",
	"./zh/Application/welding/welding-7.jpg": "2809",
	"./zh/Application/welding/welding-8.jpg": "0c0f",
	"./zh/Application/welding/welding-9.jpg": "3697",
	"./zh/Certificate/banner-1-m.jpg": "9cea",
	"./zh/Certificate/banner-1.jpg": "2d6a",
	"./zh/Certificate/certificate01-1.jpg": "50c3",
	"./zh/Certificate/certificate01-2.jpg": "af76",
	"./zh/Certificate/certificate02-1-1.jpg": "73a2",
	"./zh/Certificate/certificate02-1-2.jpg": "bd6e",
	"./zh/Certificate/certificate02-1-3.jpg": "ee2b",
	"./zh/Certificate/certificate02-1-4.jpg": "a7ec",
	"./zh/Certificate/certificate02-1-5.jpg": "8096",
	"./zh/Certificate/certificate02-1-6.jpg": "6e01",
	"./zh/Certificate/certificate02-2-1.jpg": "37d5",
	"./zh/Certificate/certificate03-1-1.jpg": "b492",
	"./zh/Certificate/certificate03-1-2.jpg": "8b68",
	"./zh/Certificate/certificate03-1-3.jpg": "9f2e",
	"./zh/Certificate/certificate03-1-4.jpg": "c71d",
	"./zh/Certificate/certificate03-2-1.jpg": "c947",
	"./zh/Certificate/certificate03-2-2.jpg": "048e",
	"./zh/Certificate/certificate03-2-3.jpg": "7464",
	"./zh/Certificate/certificate03-2-4.jpg": "b620",
	"./zh/Certificate/certificate04-1.jpg": "b472",
	"./zh/Certificate/certificate04-2.jpg": "46ac",
	"./zh/Certificate/certificate04-3.jpg": "e099",
	"./zh/Certificate/certificate04-4.jpg": "06cd",
	"./zh/Certificate/certificate04-5.jpg": "cc8d",
	"./zh/Certificate/certificate04-6.jpg": "e23d",
	"./zh/Certificate/tab01.jpg": "55b3",
	"./zh/Certificate/tab02.jpg": "c40f",
	"./zh/Certificate/tab03.jpg": "702b",
	"./zh/Certificate/tab04.jpg": "b2bc",
	"./zh/Certificate/tab05.jpg": "9206",
	"./zh/Certificate/tab06.jpg": "6a1f",
	"./zh/Contact/banner-1-m.jpg": "cffb",
	"./zh/Contact/banner-1.jpg": "30c0",
	"./zh/Customized/banner-1-m.jpg": "9bc7",
	"./zh/Customized/banner-1.jpg": "4bf2",
	"./zh/Customized/customized.jpg": "7e21",
	"./zh/Customized/customized_m.jpg": "9bc74",
	"./zh/Examples/household/banner-1-m.jpg": "7be9",
	"./zh/Examples/household/banner-1.jpg": "4acd",
	"./zh/Examples/household/family-1.jpg": "14ed",
	"./zh/Examples/household/family-10.jpg": "3316",
	"./zh/Examples/household/family-11.jpg": "4870",
	"./zh/Examples/household/family-12.jpg": "18d2",
	"./zh/Examples/household/family-13.png": "a017",
	"./zh/Examples/household/family-2.jpg": "d55e",
	"./zh/Examples/household/family-3.jpg": "e40e",
	"./zh/Examples/household/family-4.jpg": "6525",
	"./zh/Examples/household/family-5.jpg": "d53c",
	"./zh/Examples/household/family-6.jpg": "4d0a",
	"./zh/Examples/household/family-7.jpg": "26f1",
	"./zh/Examples/household/family-8.jpg": "96e2",
	"./zh/Examples/household/family-9.jpg": "292a",
	"./zh/Examples/household/family.jpg": "ce01",
	"./zh/Examples/household/restaurant-1.png": "e372",
	"./zh/Examples/household/restaurant-2.jpg": "fde3",
	"./zh/Examples/household/restaurant-3.jpg": "2e66",
	"./zh/Examples/household/restaurant-4.jpg": "8c54",
	"./zh/Examples/household/restaurant-5.jpg": "08d3",
	"./zh/Examples/household/restaurant.png": "7261",
	"./zh/Examples/pipe/banner-1-m.jpg": "0255",
	"./zh/Examples/pipe/banner-1.jpg": "db7b",
	"./zh/Examples/pipe/building95-1.jpg": "9f7f",
	"./zh/Examples/pipe/building95-2.jpg": "0c1a",
	"./zh/Examples/pipe/building95-3.jpg": "f011",
	"./zh/Examples/pipe/building95-4.jpg": "9056",
	"./zh/Examples/pipe/building95-5.jpg": "75ad",
	"./zh/Examples/pipe/building95-6.jpg": "9385",
	"./zh/Examples/pipe/building95.jpg": "1675",
	"./zh/Examples/pipe/sea-1.jpg": "3e9c",
	"./zh/Examples/pipe/sea-2.jpg": "84a7",
	"./zh/Examples/pipe/sea-3.jpg": "dd0d",
	"./zh/Examples/pipe/sea-4.jpg": "ecbc",
	"./zh/Examples/pipe/sea-5.jpg": "04ba",
	"./zh/Examples/pipe/sea-6.jpg": "a1ab",
	"./zh/Examples/pipe/sea.jpg": "fafd",
	"./zh/Examples/pipe/seaPalace-1.jpg": "14d3",
	"./zh/Examples/pipe/seaPalace-2.jpg": "4d3d",
	"./zh/Examples/pipe/seaPalace-3.jpg": "ff50",
	"./zh/Examples/pipe/seaPalace-4.jpg": "506c",
	"./zh/Examples/pipe/seaPalace.jpg": "4ed7",
	"./zh/Examples/pipe/taoyuan-1.jpg": "55b8",
	"./zh/Examples/pipe/taoyuan-2.jpg": "55d1",
	"./zh/Examples/pipe/taoyuan-3.jpg": "07e6",
	"./zh/Examples/pipe/taoyuan-4.jpg": "778c",
	"./zh/Examples/pipe/taoyuan-5.jpg": "a31a",
	"./zh/Examples/pipe/taoyuan-6.jpg": "4a63",
	"./zh/Examples/pipe/taoyuan.jpg": "e5df",
	"./zh/Examples/pipe/xinzhuang-1.jpg": "47c2",
	"./zh/Examples/pipe/xinzhuang-2.jpg": "43ad",
	"./zh/Examples/pipe/xinzhuang-3.jpg": "a8b6",
	"./zh/Examples/pipe/xinzhuang-4.jpg": "a7a0",
	"./zh/Examples/pipe/xinzhuang-5.jpg": "245b",
	"./zh/Examples/pipe/xinzhuang.jpg": "cd15",
	"./zh/Examples/seats/banner-1-m.jpg": "eed1",
	"./zh/Examples/seats/banner-1.jpg": "9372",
	"./zh/Examples/seats/seat-1.jpg": "afd1",
	"./zh/Examples/seats/seat-2.jpg": "02ab",
	"./zh/Examples/seats/seat-3.jpg": "2850",
	"./zh/Examples/seats/seat-4.jpg": "e326",
	"./zh/Examples/seats/seat-5.jpg": "12ad",
	"./zh/Examples/seats/seat-6.jpg": "914a",
	"./zh/Examples/seats/seat-7.jpg": "7b57",
	"./zh/Examples/seats/seat.jpg": "8428",
	"./zh/Examples/seats/train-1.jpg": "9787",
	"./zh/Examples/seats/train-10.jpg": "5bbd",
	"./zh/Examples/seats/train-11.jpg": "5432",
	"./zh/Examples/seats/train-2.jpg": "1755",
	"./zh/Examples/seats/train-3.jpg": "dc57",
	"./zh/Examples/seats/train-4.jpg": "ce85",
	"./zh/Examples/seats/train-5.jpg": "f9b9",
	"./zh/Examples/seats/train-6.jpg": "44b4",
	"./zh/Examples/seats/train-7.jpg": "8776",
	"./zh/Examples/seats/train-8.jpg": "9bab",
	"./zh/Examples/seats/train-9.jpg": "1615",
	"./zh/Examples/seats/train.png": "5757",
	"./zh/Examples/welding/FPG-1.jpg": "0557",
	"./zh/Examples/welding/FPG-2.jpg": "1a6f",
	"./zh/Examples/welding/FPG-3.jpg": "eda2",
	"./zh/Examples/welding/FPG-4.jpg": "1883",
	"./zh/Examples/welding/FPG-5.jpg": "094c",
	"./zh/Examples/welding/FPG-6.jpg": "d14b",
	"./zh/Examples/welding/FPG.jpg": "2506",
	"./zh/Examples/welding/banner-1-m.jpg": "4a18",
	"./zh/Examples/welding/banner-1.jpg": "b159",
	"./zh/Examples/welding/repair-1.jpg": "b70a",
	"./zh/Examples/welding/repair-2.jpg": "21db",
	"./zh/Examples/welding/repair-3.jpg": "cedc",
	"./zh/Examples/welding/repair-4.jpg": "e869",
	"./zh/Examples/welding/repair-5.jpg": "1093",
	"./zh/Examples/welding/repair-6.jpg": "c046",
	"./zh/Examples/welding/repair-7.jpg": "c7ff",
	"./zh/Examples/welding/repair.jpg": "6ce4",
	"./zh/Examples/welding/restaurant-1.jpg": "6fa2",
	"./zh/Examples/welding/restaurant-2.jpg": "2d27",
	"./zh/Examples/welding/restaurant-3.jpg": "1fe4",
	"./zh/Examples/welding/restaurant-4.jpg": "4b8e",
	"./zh/Examples/welding/restaurant-5.jpg": "1b1c",
	"./zh/Examples/welding/restaurant-6.jpg": "9be2",
	"./zh/Examples/welding/restaurant.jpg": "e38a",
	"./zh/Examples/welding/ship-1.jpg": "69c9",
	"./zh/Examples/welding/ship-2.jpg": "91a3",
	"./zh/Examples/welding/ship-3.jpg": "b338",
	"./zh/Examples/welding/ship-4.jpg": "8455",
	"./zh/Examples/welding/ship.jpg": "4a9c",
	"./zh/Examples/welding/steel-1.jpg": "5987",
	"./zh/Examples/welding/steel-2.jpg": "5a48",
	"./zh/Examples/welding/steel-3.jpg": "3ad0",
	"./zh/Examples/welding/steel-4.jpg": "ef06",
	"./zh/Examples/welding/steel-5.jpg": "2b03",
	"./zh/Examples/welding/steel-6.jpg": "a3eb",
	"./zh/Examples/welding/steel-7.jpg": "bd79",
	"./zh/Examples/welding/steel.jpg": "c3c4",
	"./zh/FireTest/banner-1-m.jpg": "2e37",
	"./zh/FireTest/banner-1.jpg": "d5952",
	"./zh/FireTest/test.jpg": "ffae",
	"./zh/FireTest/test01-1.jpg": "f607",
	"./zh/FireTest/test01-2.jpg": "e6a2",
	"./zh/FireTest/test01-3.jpg": "4f14",
	"./zh/FireTest/test01-4.jpg": "9893",
	"./zh/FireTest/test01-5.jpg": "c645",
	"./zh/FireTest/test01-6.jpg": "4a89",
	"./zh/FireTest/test02-1.jpg": "703e",
	"./zh/FireTest/test02-2.jpg": "aa1d",
	"./zh/FireTest/test03-1.jpg": "760e",
	"./zh/FireTest/test03-2.jpg": "f4ab",
	"./zh/FireTest/test03-3.jpg": "5ea4",
	"./zh/FireTest/test03-4.jpg": "099e",
	"./zh/FireTest/test03-5.jpg": "8cf3",
	"./zh/FireTest/test03-6.jpg": "9ab6",
	"./zh/FireTest/test04-1.jpg": "93ab",
	"./zh/FireTest/test04-2.jpg": "fdfb",
	"./zh/Home/application-title-m.png": "3dad",
	"./zh/Home/application-title.png": "636e",
	"./zh/Home/banner-tc1-m.jpg": "9f89",
	"./zh/Home/banner-tc1.jpg": "772c",
	"./zh/Home/banner-tc2-m.jpg": "922d",
	"./zh/Home/banner-tc2.jpg": "6e71",
	"./zh/Home/banner-tc3-m.jpg": "13aa",
	"./zh/Home/banner-tc3.jpg": "868e",
	"./zh/Home/banner-tc4-m.jpg": "dcf5",
	"./zh/Home/banner-tc4.jpg": "d50f",
	"./zh/Home/banner-tc5-m.jpg": "216a",
	"./zh/Home/banner-tc5.jpg": "c24a",
	"./zh/Home/blackcat1.jpg": "4dad",
	"./zh/Home/blackcat2.jpg": "b946",
	"./zh/Home/btnCard-1-m.jpg": "828c",
	"./zh/Home/btnCard-1.jpg": "ae7d",
	"./zh/Home/btnCard-2-m.jpg": "f540",
	"./zh/Home/btnCard-2.jpg": "d371",
	"./zh/Home/btnCard-3-m.jpg": "3cc4",
	"./zh/Home/btnCard-3.jpg": "3f34",
	"./zh/Home/btnCard-4-m.jpg": "ca12",
	"./zh/Home/btnCard-4.jpg": "3a89",
	"./zh/Home/btnCard-5-m.jpg": "d75d",
	"./zh/Home/btnCard-5.jpg": "44e1",
	"./zh/Home/btnCard-6-m.jpg": "38b3",
	"./zh/Home/btnCard-6.jpg": "f8e9",
	"./zh/Home/btnCard-7-m.jpg": "272d",
	"./zh/Home/btnCard-7.jpg": "7214",
	"./zh/Home/btnCard-8-m.jpg": "ba20",
	"./zh/Home/btnCard-8.jpg": "23de",
	"./zh/Home/c-thermometer-img1-2.png": "0262",
	"./zh/Home/c-thermometer-img2-2.png": "852a",
	"./zh/Home/c-thermometer-img3-2.png": "cfb1",
	"./zh/Home/c-thermometer-img4-2.png": "70e3",
	"./zh/Home/c-thermometer-img5-2.png": "beaa",
	"./zh/Home/c-thermometer-img6-2.png": "fb4c",
	"./zh/Home/c-thermometer-img7-1.jpg": "c7e5",
	"./zh/Home/c-thermometer-img7-2.jpg": "8741",
	"./zh/Home/c-thermometer-img7-3.jpg": "c90e",
	"./zh/Home/c-thermometer-img8-1.png": "3cdc",
	"./zh/Home/c-thermometer-img8-2.png": "eed2",
	"./zh/Home/c-thermometer-img8-3.png": "1251",
	"./zh/Home/f-thermometer-img1-2.png": "7f22",
	"./zh/Home/f-thermometer-img2-2.png": "f279",
	"./zh/Home/f-thermometer-img3-2.png": "09cd",
	"./zh/Home/f-thermometer-img4-2.png": "48eb",
	"./zh/Home/f-thermometer-img5-2.png": "760b",
	"./zh/Home/f-thermometer-img6-2.png": "911e",
	"./zh/Home/f-thermometer-img7-1.jpg": "283b",
	"./zh/Home/f-thermometer-img7-2.jpg": "c957",
	"./zh/Home/f-thermometer-img7-3.jpg": "a72e",
	"./zh/Home/f-thermometer-img8-1.png": "3df3",
	"./zh/Home/f-thermometer-img8-2.png": "7ac8",
	"./zh/Home/f-thermometer-img8-3.png": "df48",
	"./zh/Home/recommed-img1.jpg": "f0f8",
	"./zh/Home/recommed-img10.jpg": "011d",
	"./zh/Home/recommed-img2.jpg": "a9c0",
	"./zh/Home/recommed-img3.jpg": "558f",
	"./zh/Home/recommed-img4.jpg": "317d",
	"./zh/Home/recommed-img5.jpg": "ff00",
	"./zh/Home/recommed-img6.jpg": "f9f3",
	"./zh/Home/recommed-img7.jpg": "704d1",
	"./zh/Home/recommed-img8.jpg": "d2ce",
	"./zh/Home/recommed-img9.jpg": "4cc8",
	"./zh/Home/thermometer-arrow-1.png": "afee",
	"./zh/Home/thermometer-arrow-2.png": "2cad",
	"./zh/Home/thermometer-img1-1.png": "723e",
	"./zh/Home/thermometer-img2-1.png": "64a3",
	"./zh/Home/thermometer-img3-1.png": "31f0",
	"./zh/Home/thermometer-img4-1.png": "d865",
	"./zh/Home/thermometer-img5-1.png": "b709",
	"./zh/Home/thermometer-img6-1.png": "ebe3",
	"./zh/Home/thermometer-title-m.png": "d04d",
	"./zh/Home/thermometer-title.png": "50dc",
	"./zh/logo.png": "861f",
	"./zh/test.jpg": "6f62e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";